import { render, staticRenderFns } from "./Sound.vue?vue&type=template&id=29fe0e8b&"
import script from "./Sound.vue?vue&type=script&lang=js&"
export * from "./Sound.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports